<template>
  <div class="supplierCostEntry">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="multi-table" v-if="form.DetailList">
        <van-field name="stepper" :label="$t.supplierCostEntry.title" required>
          <template #input>
            <van-stepper
              :min="0"
              :value="form.DetailList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.DetailList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.Customer.text"
            :label="$t.supplierCostEntry.customName"
            :placeholder="$t.meta.input"
            @click="onShowEmit('showSupplierCostEntryCustomer', index)"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.Customer.CustomerNumber"
            :label="$t.supplierCostEntry.customerNumber"
            disabled
          />
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="onShowEmit('showBillsReceivableItem', index)"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.Quantity"
            :label="$t.supplierCostEntry.quantity"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            @blur="handleUnitPrice(index)"
            clickable
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.UnitPrice"
            :label="$t.supplierCostEntry.unitPrice"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            @blur="handleUnitPrice(index)"
            clickable
            required
            :rules="formRule"
          />
          <van-field
            :value="(item.Quantity * item.UnitPrice).toFixed(2)"
            :label="$t.supplierCostEntry.total"
            readonly
          />
          <van-field
            v-model="item.SupplierBillReferNo"
            :label="$t.supplierCostEntry.referNo"
            :placeholder="$t.meta.input"
            clickable
          />
          <van-field :label="$t.supplierCostEntry.attachments">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.AttachmentAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="item.AttachmentAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead1" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.AttachmentAddress && imgUrlFilter(item.AttachmentAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.AttachmentAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
          <van-field :label="$t.supplierCostEntry.taxInvoice">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.TaxInvoice))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="item.TaxInvoice"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead2" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.TaxInvoice && imgUrlFilter(item.TaxInvoice)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.TaxInvoice"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
          <van-field
            v-model="item.Remark"
            :label="$t.supplierCostEntry.remark"
            :placeholder="$t.meta.input"
            clickable
            type="textarea"
          />
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>

    <fetch-list
      event="showSupplierCostEntryCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <option-list
      event="showBillsReceivableItem"
      :options="billPaymentList"
      @onSelect="itemConfirm"
    ></option-list>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <div class="tool-bar">
      <div class="tool-bar-wrapper" v-if="showStatistics">
        <van-button block @click="showStatistics = false">{{
          $t.meta.hideStatistics
        }}</van-button>

        <div class="tool-bar-total" v-if="ReceiveList && ReceiveList.length > 0">
          <div class="tool-bar-total-left">{{ $t.supplierCostEntry.amount }}</div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in ReceiveList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount.toFixed(2) }}</div>
          </div>
        </div>
      </div>
      <div class="tool-bar-wrapper" v-else>
        <van-button type="info" block @click="showStatistics = true">{{
          $t.meta.showStatistics
        }}</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon, Image, Stepper, Popup, Picker } from "vant";

import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Image)
  .use(Stepper)
  .use(Popup)
  .use(Picker);

export default {
  name: "supplierCostEntry",
  components: {
    FetchList,
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      WGId: "",
      TOId: "",
      form: {
        DetailList: [
          {
            FinancialAccountNo: "",
            CustomerId: null,
            Customer: {},
            BillId: "",
            BillName: "",
            Quantity: "",
            UnitPrice: "",
            Currency: "",
            CurrencySn: "",
            Amount: "",
            SupplierBillReferNo: "",
            AttachmentAddress: "",
            TaxInvoice: "",
            Remark: "",
            //编辑
            PWB_Number: "",
            WGId: "",
          },
        ],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      FinancialAccountNo: "",
      PWB_Number: "",
      WB_Number: "",
      WBIdList: "",
      currencyList: [],
      billPaymentList: [],
      itemIndex: 0,
      filesIndex: 0,
      showCurrencyPicker: false,
      //统计
      showStatistics: false,
      ReceiveList: [],
    };
  },
  created() {
    const {
      FinancialAccountNo,
      PWB_Number,
      WB_Number,
      WGId,
      TOId,
      WB_Id,
    } = this.$route.query;
    if (FinancialAccountNo) {
      this.FinancialAccountNo = FinancialAccountNo;
      this.getOptions().then((success) => {
        if (success) {
          this.getSupplierCostDetails();
        }
      });
    } else {
      if (PWB_Number) {
        this.PWB_Number = PWB_Number;
      }
      if (WB_Number) {
        this.WB_Number = WB_Number;
      }
      if (WGId) {
        this.WGId = WGId;
      }
      if (TOId) {
        this.TOId = TOId;
      }
      if (WB_Id) {
        this.WBIdList = WB_Id;
      }
      this.getOptions();
    }
  },
  methods: {
    getSupplierCostDetails() {
      this.$commonMethod.showLoading();
      this.$api.financialManagement
        .getSupplierCostDetails({
          CompanyId: this.CompanyId,
          FinancialAccountNo: this.FinancialAccountNo,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            var cur = this.currencyList.find((c) => c.value == item.Currency);
            var bill = this.billPaymentList.find((c) => c.value == item.BillId);
            let data = {
              PWB_Number: item.PWB_Number,
              WGId: item.WGId,
              CostId: item.CostId,
              FinancialAccountNo: item.FinancialAccountNo,
              CustomerId: item.CustomerId,
              Customer: {
                text: item.CompanyNameSn,
                value: item.CustomerId,
                CustomerNumber: item.CustomerNumber,
              },
              BillId: item.BillId,
              BillName: bill ? bill.text : "",
              Quantity: item.Quantity,
              UnitPrice: item.UnitPrice,
              Currency: item.Currency,
              CurrencySn: cur ? cur.text : "",
              Amount: item.Amount,
              SupplierBillReferNo: item.SupplierBillReferNo,
              AttachmentAddress: item.AttachmentAddress,
              TaxInvoice: item.TaxInvoice,
              Remark: item.Remark,
            };
            result.push(data);
          });
          this.form.DetailList = result;
          this.PWB_Number = result[0].PWB_Number;
          this.WGId = result[0].WGId;
          this.calculate();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleUnitPrice(index) {
      var item = this.form.DetailList[index];
      var price = (item.Quantity * item.UnitPrice).toFixed(2);
      this.form.DetailList[index].Amount = price;
      this.calculate();
    },
    calculate() {
      for (const receive of this.ReceiveList) {
        receive.TotalAmount = 0;
        var array = this.form.DetailList.filter((item) => item.Currency == receive.SCId);
        for (const ar of array) {
          receive.TotalAmount = receive.TotalAmount + parseFloat(ar.Amount);
        }
      }
    },
    handleDelByIndex(index) {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.pop();
      }
    },
    handleAdd() {
      this.form.DetailList.push({
        FinancialAccountNo: "",
        CustomerId: null,
        Customer: {},
        BillId: "",
        BillName: "",
        Quantity: "",
        UnitPrice: "",
        Currency: "",
        CurrencySn: "",
        Amount: "",
        SupplierBillReferNo: "",
        AttachmentAddress: "",
        TaxInvoice: "",
        Remark: "",
      });
    },
    pickerShow(index, pickerName) {
      this[pickerName] = true;
      this.itemIndex = index;
    },
    itemConfirm(item) {
      this.form.DetailList[this.itemIndex].BillName = item.text;
      this.form.DetailList[this.itemIndex].BillId = item.value;
    },
    currencyConfirm(e) {
      if (!e) {
        return;
      }
      this.form.DetailList[this.itemIndex].CurrencySn = e.text;
      this.form.DetailList[this.itemIndex].Currency = e.value;
      this.handleUnitPrice(this.itemIndex);
      this.showCurrencyPicker = false;
    },
    onSelectCustomer(item) {
      this.form.DetailList[this.itemIndex].Customer.text = item.text;
      this.form.DetailList[this.itemIndex].Customer.value = item.value;
      this.form.DetailList[this.itemIndex].Customer.CustomerNumber = item.CustomerNumber;
      this.$forceUpdate();
    },
    onShowEmit(emit, idx) {
      this.itemIndex = idx;
      this.$bus.$emit(emit, true);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var arr = this.form.DetailList;
      var param = {
        CompanyId: this.CompanyId,
        UserId: this.UserId,
      };
      var request = null;
      if (this.FinancialAccountNo) {
        for (let i in arr) {
          arr[i].CustomerId = arr[i].Customer.value;
        }
        param.SCDList = arr;
        param.PWB_Number = this.PWB_Number;
        param.WGId = this.WGId;
        param.TOId = this.TOId;
        request = this.$api.logisticsManagement.editSupplierCostDetails(param);
      } else {
        for (let i in arr) {
          arr[i].Amount =
            (Number(arr[i].Quantity) * Number(arr[i].UnitPrice)).toString() || 0;
          arr[i].CustomerId = arr[i].Customer.value;
          arr[i].WBIdList = this.WBIdList;
        }
        param.SCDList = arr;
        param.PWB_Number = this.PWB_Number;
        param.WB_Number = this.WB_Number;
        param.WGId = this.WGId;
        param.TOId = this.TOId;
        request = this.$api.logisticsManagement.addSupplierCostDetails(param);
      }
      request
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.operateSuccess,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getBillPaymentList(), this.getCurrencyList()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            if (this.currencyList.length > 0) {
              for (var currency of this.currencyList) {
                this.ReceiveList.push({
                  SCId: currency.value,
                  CurrencySn: currency.text,
                  TotalAmount: 0,
                });
              }
            }
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getBillPaymentList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getBillPaymentListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.BillId,
              };
              result.push(data);
            });
            this.billPaymentList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.DetailList[this.filesIndex].AttachmentAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.DetailList[this.filesIndex].TaxInvoice = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.supplierCostEntry {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;
      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        width: 50%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        .van-icon {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }
  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;
    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .checkbox {
        display: inline-flex;
        span {
          margin-left: 10px;
        }
      }
    }
    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
